module.exports = __webpack_public_path__ + "media/images/emblems/Ferreyres-coat_of_arms-3510181d919e46ac7728a33cd049568b.svg";